import React, { Component } from 'react';
import './PrivacyPolicy.css';
import { NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom'

class PrivacyPolicy extends Component {

    constructor(props){
        super(props);
    }

    componentDidMount() {
        document.title = 'Privacy Policy';
    }

    render () {
          return (
            <div>
              <div> 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white', width:'100%', background: '#333F50'}} tag={Link} to={'/login'}>
                                                swipequotes
                                                </NavLink>
                </div>
            <div className="privacyPolicyContainer">
            <div className="privacyPolicyHeader"> Privacy and Content Policy</div>
            <p>
              The services are provided by Swipenine Private Limited (parent company and hereinafter referred to as “SwipeQuotes”), an Indian company with registered address at 65/2593, Second Floor, GECO Complex, Nadakkavu, Calicut, Kerala, India 673011.<br></br>
              SwipeQuotes is our modest attempt to share the literary works of prominent individuals from across the world - words that offer bursts of wisdom, inspiration, insights and perspectives - to reinforce knowledge, influence or motivate us - or sometimes to find a voice that echos our thoughts and give us some direction. We don’t prohibit right of expression.<br></br>
              On the other hand, to maintain the decorum and moral values, it is essential for us to refrain from abuses. To achieve the above mentioned aim, we have set some restrictions on the type of content that can be posted in SwipeQuotes. The said restrictions comply with legal requirements and also will add value to our services and it’s applicable to website and apps respectively. No information of the user will be collected via SwipeQuotes app, unless and until account creation is enabled or utilized.<br></br>
              If you experience any content which you believe violates our policies, please report the same to SwipeQuotes Team.
            </p>
            <div className="privacyPolicySubHeader">Information We Collect</div>
            <p>
              We may collect the following types of information:<br></br>
              a. Personal Information<br></br>
              Provided voluntarily when using features such as accounts, subscriptions, or support requests. Examples:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Name</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Email address</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Account login details</span><br></br>
              b. Usage Data<br></br>
              Automatically collected to improve performance:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Device type & operating system</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	IP address</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Browsing behavior within the app/website</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Interaction activity (favorites, shares, etc.)</span><br></br>
              c. Cookies and Tracking<br></br>
              We use cookies and analytics tools to understand user interaction and improve service quality.<br></br>
              d. User-Generated Content<br></br>
              Quotes, comments, or contributions published through the platform.
            </p>
            <div className="privacyPolicySubHeader">Affiliate Disclosure & Additional Cookie Policies</div>
            <p>
              Some of the links found on SwipeQuotes are affiliate referral links. This means that if a reader clicks on text or an image, we may receive a commission from purchases. There is no additional cost to you — it helps pay for maintenance of the entire project. Thanks!<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	SwipeQuotes is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to amazon.in</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	SwipeQuotes is a participant in the Google Adsense Program, an advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to relevant ad partners.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Third party vendors, including Amazon, Google etc. use cookies to serve ads based on a user’s prior visits to your pages and/or other websites.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Use of advertising cookies enables it and its partners to serve ads to your users based on their visit to your pages and/or other websites on the Internet.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Users may opt out of personalized advertising by visiting Google Ads Settings or by visiting https://www.aboutads.info</span>
            </p>
            <div className="privacyPolicySubHeader">How We Use Your Information</div>
            <p>
              We use collected information (if any) to:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Improve user experience and personalize content<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Operate and maintain the Service<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Respond to support inquiries<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Provide updates, newsletters, and notifications (only with consent)<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Prevent misuse or security violations<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Analyze performance and usage trends
            </p>
            <div className="privacyPolicySubHeader">Sharing of Information</div>
            <p>
              We do not sell or trade personal information. We may share limited data:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	With trusted third-party services like analytics or cloud hosting<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	To comply with legal or governmental requirements<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	To prevent fraud or protect rights and safety

            </p>
            <div className="privacyPolicySubHeader">Data Protection & Security</div>
            <p>
              We use encryption, secure storage, and industry-standard safeguards. However, no method is 100% secure, and we cannot guarantee absolute protection.
            </p>
            <div className="privacyPolicySubHeader">User Rights</div>
            <p>
              You may request:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Access to your stored data<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Correction or deletion of your data<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Unsubscribe from email services<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Account deletion<br></br>
              Contact: swipenine@outlook.com
            </p>
            <div className="privacyPolicySubHeader">Children’s Privacy</div>
            <p>
              SwipeQuotes is not intended for children under 13. We do not knowingly collect personal data from minors.
            </p>
            <div className="privacyPolicySubHeader">Third-Party Content & Links</div>
            <p>
              External links or ads are not controlled by SwipeQuotes. We are not responsible for their policies.
            </p>
            <div className="privacyPolicySubHeader">Changes to Privacy Policy</div>
            <p>
              We may update this policy occasionally. Continued use means acceptance of changes.
            </p>
            <div className="privacyPolicySubHeader">Content Restrictions</div>
            <p>
              SwipeQuotes content policies play a vital role in enhancing the user experience and these policies are subject to change from time to time. Please keep yourself updated with the latest policies and respect the same. Granting exceptions on the contents are solely under the discretion of SwipeQuotes.<br></br>
              The following contents are strictly prohibited in the contents which will be posted in SwipeQuotes.
            </p>
            <div className="privacyPolicySubHeader">Adult contents</div>
            <p>
              Posting/promoting of any contents/ideas (words, images, video & audio) that contain nudity or sexual activity is strictly prohibited. The publishing of such contents will be done post scrutiny by the SwipeQuotes Team, if found satisfactory. Please refrain from posting contents of below mentioned nature:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Refrain from posting illegal sexual contents to include image, video or textual contents which showcase or encourage rape, incest, bestiality, or necrophilia.<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Do not post private nude/sexually explicit images or videos without the subject’s consent. Please report if it is contrary to above.
            </p>
            <div className="privacyPolicySubHeader">Child Abuse contents</div>
            <p>
              Any contents exploiting children should not be posted in SwipeQuotes. Following are the few examples on the same:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Child sexual abuse imagery, text, video and audio files.<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	Pedophilia: Content of a sexual nature involving an underage participant.
            </p>
            <div className="privacyPolicySubHeader">Hate speech</div>
            <p>
              Even though our platform provide freedom of expression, we restrict from supporting contents posted/promoted on violence against individuals or groups based on race or ethnic origin, religion, disability, gender, age, nationality, veteran status, or sexual orientation/gender identity, or promoting hatred.
            </p>
            <div className="privacyPolicySubHeader">Crude contents and violence</div>
            <p>
              Accident scenes or any image’s brutal in nature. Also, do not promote any contents which may initiate aggravate violence amongst people/group of people, religion, ethnicity, caste, creed, gender, political ideology/group, sex, etc.
            </p>
            <div className="privacyPolicySubHeader">Harassment and bullying</div>
            <p>
              Any users performing the act of bullying or harassing using offending contents will be removed or be permanently banned from the site. Online harassment is Illegal in many places and will have serious legal consequences.
            </p>
            <div className="privacyPolicySubHeader">Personal and confidential information</div>
            <p>
              Please refrain from posting private and personal information of others without their consent, as it is illegal.
            </p>
            <div className="privacyPolicySubHeader">Impersonating others</div>
            <p>
              Avoid activities/contents which deface/hide your true identity.
            </p>
            <div className="privacyPolicySubHeader">Illegal activities</div>
            <p>
              No contents will be permitted to be posted which promotes illegal activities and messages.
            </p>
            <div className="privacyPolicySubHeader">Spam, Malware and Services</div>
            <p>
              Do not create contents that transmit viruses, create pop-ups, attempt to install software without the reader’s consent or otherwise impact reader’s with malicious code. Above mentioned activities are strictly prohibited.
            </p>
            <div className="privacyPolicySubHeader">Review of Content by SwipeQuotes</div>
            <p>
              All the users are requested to report suspected content violations to the SwipeQuotes Team. Our team will review all the contents shared by members prior to posting it in the website. Any article that is found to be violating the SwipeQuotes content policies will be subject to the following actions:<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	The detected content/article will be deleted or will not be posted.<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	The author may be removed/suspended from posting article.<br></br>
              <span style={{padding: "0 0 0 10px"}}></span>•	User may be taken to law enforcement authorities as the case may be.<br></br><br></br>
              Click here to know More : <a href="https://swipequotes.com/questions">https://swipequotes.com/questions/</a><br></br><br></br>
              Last Updated : 04 January 2026
            </p>

          </div>
          <div className='privacyPolicyFooter'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
            </div>
           
          )
    }
  }
  
  export default PrivacyPolicy